import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/entities/api.service';

@Injectable({
  providedIn: 'root',
})
export class ApiReportsService extends ApiService {
  getWikiUsage(params: { page?: number; pageSize?: number; sortBy?: string; sortDir?: string }) {
    return this.http.get<any>(this.getApiUrl(`reports/wiki-usage${this.toQueryString(params)}`));
  }

  getWikiArticleReaders(
    wikiId: string,
    params: { page?: number; pageSize?: number } = {}
  ) {
    return this.http.get<any>(this.getApiUrl(`reports/wiki-article-readers/${wikiId}${this.toQueryString(params)}`));
  }

  getWikiUserArticles(
    userId: string,
    params: { page?: number; pageSize?: number } = {}
  ) {
    return this.http.get<any>(this.getApiUrl(`reports/wiki-user-articles/${userId}${this.toQueryString(params)}`));
  }

  getAiUsage(params: { dateFrom?: string; dateTo?: string; page?: number; pageSize?: number; sortBy?: string; sortDir?: string }) {
    return this.http.get<any>(this.getApiUrl(`reports/ai-usage${this.toQueryString(params)}`));
  }

  private toQueryString(params: { [key: string]: any }) {
    const entries = Object.keys(params || {})
      .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== '')
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);

    return entries.length ? `?${entries.join('&')}` : '';
  }
}

